import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiExternalLink } = FiIcons;

const About = () => {
  return (
    <section className="pt-40 pb-24 bg-[#07113a]">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <span className="text-[#3b82f6] font-bold tracking-widest uppercase text-xs mb-4 block">About the Studio</span>
          <h1 className="text-5xl md:text-7xl font-black text-white mb-12 tracking-tight uppercase">
            Rapid City born.<br />Built to ship.
          </h1>

          <div className="space-y-8 text-xl text-[#e2e8f0] leading-relaxed font-medium">
            <p>
              Crucible Lab is a product studio founded by Claton Butcher in Rapid City, South Dakota. We exist to bridge the gap between high-level strategy and real-world execution.
            </p>
            <p>
              With more than a dozen digital products shipped and maintained, we bring a level of battle-tested experience that generic agencies can't match. When you hire Crucible Lab, you get direct access to Claton—no account managers, no handoffs, no anonymous developers.
            </p>
            <p>
              Crucible Lab is a studio inside 102:18 INC, which holds our various ventures and LLCs, including CrossCurrent Digital, Two Words Publishing, Black Hills Audiobooks, Vision Audiobooks, RouteCaster.app, Fidelis AI, and Crucible Lab LLC.
            </p>
          </div>

          <div className="mt-24 pt-24 border-t border-[#344271]">
            <h3 className="text-2xl font-black text-white mb-8 uppercase tracking-tight">Recent Local Work</h3>
            <div className="grid sm:grid-cols-2 gap-6">
              <a
                href="https://twocows-proposal.netlify.app"
                target="_blank"
                rel="noopener noreferrer"
                className="p-10 bg-[#2a3658] border border-[#344271] rounded-[32px] hover:border-[#3b82f6]/40 transition-all group backdrop-blur-sm shadow-xl"
              >
                <h4 className="text-white font-black text-xl mb-2 group-hover:text-white transition-colors uppercase tracking-tight">Two Cows Creamery and Bistro</h4>
                <p className="text-[#94a3b8] text-sm mb-8 font-medium">Website proposal for a local bistro</p>
                <span className="text-xs font-black text-[#3b82f6] uppercase tracking-[0.2em] flex items-center group-hover:gap-2 transition-all">
                  View Proposal <SafeIcon icon={FiExternalLink} className="ml-2" />
                </span>
              </a>
              <a
                href="https://homeschoolsd.org"
                target="_blank"
                rel="noopener noreferrer"
                className="p-10 bg-[#2a3658] border border-[#344271] rounded-[32px] hover:border-[#3b82f6]/40 transition-all group backdrop-blur-sm shadow-xl"
              >
                <h4 className="text-white font-black text-xl mb-2 group-hover:text-white transition-colors uppercase tracking-tight">HomeschoolSD.org</h4>
                <p className="text-[#94a3b8] text-sm mb-8 font-medium">Active community site rebuild</p>
                <span className="text-xs font-black text-[#3b82f6] uppercase tracking-[0.2em] flex items-center group-hover:gap-2 transition-all">
                  Visit Site <SafeIcon icon={FiExternalLink} className="ml-2" />
                </span>
              </a>
            </div>
            <p className="mt-8 text-[#64748b] italic text-sm text-center font-medium uppercase tracking-widest">More samples available on request.</p>
          </div>

          <div className="mt-24 py-16 px-10 bg-[#2a3658] rounded-[40px] border border-[#344271] text-center backdrop-blur-sm relative overflow-hidden shadow-2xl">
            <div className="absolute inset-0 bg-[#3b82f6]/5 pointer-events-none"></div>
            <h3 className="text-[#3b82f6] font-bold tracking-widest uppercase text-xs mb-8 relative z-10">Our Mission</h3>
            <p className="text-3xl md:text-4xl font-black text-white italic relative z-10 leading-relaxed tracking-tight">
              "Build real, working digital products—for clients and for users—and keep improving them after launch."
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default About;